import React, { useEffect } from 'react';
import style from './adBanner.less';
import * as analytics from '../../lib/analytics';
import PromoMessage from '../../redesignComponents/promoMessage/__stories__/promoMessage';
import { v2blue700 } from '@paypalcorp/pp-react';
import { useMediaQuery } from 'react-responsive';

const AdBanner = ({ fptiInfo, i18n, cdnHost }) => {
  useEffect(() => {
    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );

    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );

    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_LOADED, {
      e: 'av',
      item_name: 'dw_giving',
      scope: 'module',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      state: 'loaded',
      acct_cntry: contentCountry,
      card_type: 'fundraiser_trending',
      tile_id: 'AdBanner',
      lcid: '-', // TODO Check how to get the lcid
      order: 2,
      module: 'generosity_network',
    });

    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_SHOWN, {
      e: 'im',
      item_name: 'dw_giving',
      scope: 'module',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      module: 'generosity network',
      state: 'populated',
      acct_cntry: contentCountry,
      card_type: 'fundraiser_trending',
      tile_id: 'AdBanner',
      lcid: '-', // TODO Check how to get the lcid
      order: 2,
    });
  }, []);

  const isSmallScreen = useMediaQuery({ query: '(max-width: 600px)' });

  return (
    <PromoMessage
      header={i18n('label.banner-title')}
      headerSize='sm'
      subHeader={i18n('label.banner-subtitle')}
      CTAText={i18n('label.banner-button')}
      CTAUrl={i18n('label.banner-link')}
      imageUrl={`https://${cdnHost}/paypal-ui/illustrations/focused/svg/reach-around-the-world-2.svg`}
      imagePosition='right'
      hasImageOffset={false}
      backgroundColor={v2blue700}
      promoContainerOffset={true}
      isDarkBackground={true}
      imageProps={{
        mobilePosition: 'bottom',
        width: isSmallScreen ? '300px' : '350px',
        height: isSmallScreen ? '244px' : '286px',
      }}
      onClick={() => {
        if (fptiInfo) {
          analytics.trackLinkWithData(
            'BannerCTA',
            fptiInfo.pgrp,
            fptiInfo.page,
            {
              link: i18n('label.banner-link'),
            },
            'link'
          );
        }
      }}
    />
  );
};

export default AdBanner;
